module.exports = __webpack_public_path__ + "static/santiment-afb77da9af255675ade9640dfd5c6381.png";